<template>
  <div>

    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>圈定条件/原始数据</span>
            </div>
            <el-row :gutter="20">
              <el-form ref="form" :model="queryForm" label-width="80px" size="mini">
                <el-form-item label="地区">
                  <el-select v-model="queryForm.region" placeholder="请选择地区">
                    <el-option label="南充市" value="南充市" selected></el-option>
                    <el-option label="南京市" value="南京市"></el-option>
                  </el-select>
                  <el-button type="primary"
                             style="margin-left: 20px;background-color: rgb(46, 205, 129); border-color: rgb(46, 205, 129); color: white;"
                             @click="onSubmit">获取数据
                  </el-button>
                </el-form-item>

              </el-form>

              <el-table
                  :data="user_info_origin_list"
                  height="466px"
                  :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                  :row-class-name="tableRowClassName"
                  style="width: 100%;">
                <el-table-column prop="patient_name" label="姓名"></el-table-column>
                <el-table-column prop="province" label="省份"></el-table-column>
                <el-table-column prop="patient_phone" label="手机号"></el-table-column>
                <el-table-column prop="city" label="城市"></el-table-column>
                <el-table-column prop="gender" label="性别"></el-table-column>
                <el-table-column prop="patient_birthday" label="出生日期"></el-table-column>
                <el-table-column prop="patient_address" label="家庭住址"></el-table-column>
              </el-table>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>


    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header-red"></i>
              <span>脱敏后数据</span>
            </div>
            <el-row :gutter="20">
              <el-table
                  :data="user_info_encrypted_list"
                  height="466px"
                  :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                  :row-class-name="tableRowClassName"
                  style="width: 100%;">
                <el-table-column prop="patient_name" label="姓名"></el-table-column>
                <el-table-column prop="province" label="省份"></el-table-column>
                <el-table-column prop="patient_phone" label="手机号(截断)"></el-table-column>
                <el-table-column prop="city" label="城市(掩码)"></el-table-column>
                <el-table-column prop="gender" label="性别(哈希)"></el-table-column>
                <el-table-column prop="patient_birthday" label="出生日期(局部混淆)"></el-table-column>
                <el-table-column prop="patient_address" label="家庭住址(隐藏)"></el-table-column>
              </el-table>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>

  </div>

</template>

<script>
export default {
  name: "DataMixup",
  data() {
    return {
      queryForm: {
        region: '南充市',
      },
      user_info_origin_list: null,
      user_info_encrypted_list: null,
    };
  },
  mounted() {
    this.onSubmit()
  },
  methods: {
    onSubmit() {
      this.$http.post(process.env.VUE_APP_API_HOST + "/service_encrypt", this.queryForm, {"content-type": "application/json"}).then((res) => {
        this.user_info_origin_list = res.data.data;
        this.user_info_encrypted_list = res.data.data_encrypted;
      })
    },

    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },


  },


}
</script>

<style scoped>
.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}
</style>
